<template>
  <div>
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">K线查询</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <!-- <base-button size="sm" type="neutral">reload</base-button> -->
          <!-- <base-button size="sm" type="neutral">Filters</base-button> -->
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <div>
            <div class="row">
              <div class="col-sm-12">
                <div style="margin-left: 30px">
                  <b-row style="padding-top: 40px">
                    <el-select
                      class="select-primary pagination-select"
                      v-model="marketId"
                      placeholder="选择交易对"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in markets"
                        :key="item.id"
                        :label="
                          item.id > 0
                            ? item.id + ' (' + item.symbol + ')'
                            : '选择交易对'
                        "
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>

                    <el-select
                      class="select-primary pagination-select"
                      v-model="period"
                      placeholder="Period"
                      style="margin-left: 10px; width: 150px"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in periodsAry"
                        :key="item.key"
                        :label="item.key != '' ? item.value : 'Select period'"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>

                    <base-button
                      style="margin-left: 30px"
                      size="sm"
                      type="neutral"
                      @click="reloadData()"
                      >reload</base-button
                    >

                    <base-button
                      style="margin-left: 30px"
                      size="sm"
                      type="neutral"
                      @click="reloadBuild()"
                      >手工同步</base-button
                    >

                    <base-button
                      style="margin-left: 30px"
                      size="sm"
                      type="neutral"
                      @click="reloadBuildAll()"
                      >手工同步所有K线</base-button
                    >
                  </b-row>
                </div>

                <el-table
                  :data="tableData"
                  header-row-class-name="thead-light"
                  style="width: 100%; margin-top: 40px"
                  :row-style="{ height: '80px' }"
                >
                  <el-table-column label="id" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{
                        (row[0] * 1000) | dateTime
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="开" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row[1] | formatPrice }} <br />
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="高" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row[4] | formatPrice }} <br />
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="低" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row[3] | formatPrice }} <br />
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="收" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row[2] | formatPrice }} <br />
                      </span>
                    </template>
                  </el-table-column>

                  <!-- <el-table-column label="rsi11" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row[16] }} <br /> </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="rsi19" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row[17] }} <br /> </span>
                    </template>
                  </el-table-column> -->

                  <!-- <el-table-column label="dpo" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">dpo:{{ row[18] }} <br /> </span>
                      <span class="table-cell">ma:{{ row[19] }} <br /> </span>
                    </template>
                  </el-table-column> -->

                  <!-- <el-table-column label="dmi" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row[20] }} <br /> </span>
                    </template>
                  </el-table-column> -->

                  <!-- <el-table-column label="HCL3" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row[5] | formatPrice }} <br />
                      </span>
                    </template>
                  </el-table-column> -->

                  <!-- <el-table-column label="日HCL3" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row[15] | formatPrice }} <br />
                      </span>
                    </template>
                  </el-table-column> -->

                  <!-- <el-table-column label="C11-34" align="left" min-width="40px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row[6] }} <br /> </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="C11-48" align="left" min-width="40px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row[21] }} <br /> </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="S11" align="left" min-width="40px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row[24] }} <br /> </span>
                    </template>
                  </el-table-column> -->
                  <el-table-column label="tick" align="left" min-width="280px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">
                        {{ row[13]|formatBL }}
                        </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="tick" align="left" min-width="200px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">
                        <textarea style="width:200px;height:100px; "
                    class=" textarea-autosize"
                    placeholder="Event Desctiption">{{ row[13] }}
          </textarea>
                        
                        </span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column label="jma-26" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row[7] }} <br /> </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="jma-24" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row[22] }} <br /> </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="ttm" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row[23] }} <br /> </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="atr" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row[8] | formatPrice }} <br />
                      </span>
                    </template>
                  </el-table-column> -->
                  <!--
                  <el-table-column label="K10" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row[9] | formatPrice }} <br />
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="K15" align="left" min-width="80px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row[10] | formatPrice }} <br />
                      </span>
                    </template>
                  </el-table-column> -->
                  <!-- <el-table-column
                    label="背离(5)"
                    align="left"
                    min-width="80px"
                  >
                    <template slot-scope="{ row }">
                      <span class="table-cell">
                        {{ row[11] | formatBL }} <br />
                      </span>
                    </template>
                  </el-table-column> -->
                  <!-- <el-table-column
                    label="背离(6)"
                    align="left"
                    min-width="80px"
                  >
                    <template slot-scope="{ row }">
                      <span class="table-cell">
                        {{ row[15] | formatBL }} <br />
                      </span>
                    </template>
                  </el-table-column> -->
                  <!-- <el-table-column
                    label="背离(7)"
                    align="left"
                    min-width="80px"
                  >
                    <template slot-scope="{ row }">
                      <span class="table-cell">
                        {{ row[13] | formatBL }} <br />
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="背离(8)"
                    align="left"
                    min-width="80px"
                  >
                    <template slot-scope="{ row }">
                      <span class="table-cell">
                        {{ row[14] | formatBL }} <br />
                      </span>
                    </template>
                  </el-table-column> -->
                </el-table>
              </div>
              <div
                slot="footer"
                class="
                  col-12
                  d-flex
                  justify-content-center justify-content-sm-between
                  flex-wrap
                "
                style="padding: 20px"
              ></div>
            </div>
            <!-- </card> -->
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>

<script>
var moment = require("moment");
import {
  TimeSelect,
  CheckboxGroup,
  Checkbox,
  Input,
  DatePicker,
  Select,
  Option,
  Scrollbar,
  Table,
  TableColumn,
} from "element-ui";

import linearSwapApi from "../../api/linearswap";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { extend } from "vee-validate";
import { required, email, min, numeric } from "vee-validate/dist/rules";
import {
  BaseCheckbox,
  BaseRadio,
  BaseProgress,
  RouteBreadCrumb,
  BasePagination,
} from "@/components";
import swal from "sweetalert2";
extend("required", required);
extend("min", min);
extend("numeric", numeric);

export default {
  components: {
    BasePagination,
    flatPicker,
    [Table.name]: Table,
    [Input.name]: Input,
    [TableColumn.name]: TableColumn,
    [TimeSelect.name]: TimeSelect,
    [Select.name]: Select,
    [Option.name]: Option,
    [Scrollbar.name]: Scrollbar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
  },
  filters: {
    formatRSI(val) {
      val = JSON.parse(val);
      var str = [];
      str.push("RSI:", Math.floor(val.rsi * 100000000) / 100000000);
      str.push("MA:", Math.floor(val.rsiMa * 100000000) / 100000000);
      return str.join("");
    },
    formatBL(val) {
      val = JSON.parse(val);
      var str = [];
      if (val.underReverse) {
        str.push("底背离--有效价");
        str.push(val.red.waitPrice);
        // str.push("底高");
        // str.push(val.red.currLowAreaHigh);
      }
      if (val.topReverse) {
        str.push("顶背离--有效价");
        str.push(val.green.waitPrice);
        // str.push("顶高");
        // str.push(val.green.currHigh);
      }
      return str.join("-");
    },
    formatPrice(val) {
      if (val) {
        return Math.floor(val * 100000000) / 100000000;
      } else {
        return "";
      }
    },

    dateTime(val) {
      var m = moment(val);
      return m.format("YYYY-MM-DD HH:mm:ss");
    },
    formatStochRSI: function (val) {
      if (!val || val == "") {
        return "";
      }
      //  "stochRSI" : "{\"stochRSI\":100,\"k\":94.34746467165421,\"d\":80.3972847708527}",

      val = JSON.parse(val);
      var stochRSI = Math.floor(val.stochRSI * 100) / 100;
      var k = Math.floor(val.k * 100) / 100;
      var d = Math.floor(val.d * 100) / 100;
      return [stochRSI, " K:", k, " D:", d].join("  ");
    },
    formatKDJ: function (val) {
      if (!val || val == "") {
        return "";
      }

      const types = Object.prototype.toString.call(val).slice(8, -1);
      if (types === "Array") {
        val = val[0];
      } else {
        val = JSON.parse(val);
      }

      var k = Math.floor(val.K * 100) / 100;
      var d = Math.floor(val.D * 100) / 100;
      var j = Math.floor(val.J * 100) / 100;
      return ["K:", k, " D:", d, " J:", j].join("  ");
    },
    formatMACD: function (val) {
      if (!val || val == "") {
        return "";
      }

      //{"MACD":142.502531932907,"signal":76.2872318412544,"histogram":66.21530009165261}
      val = JSON.parse(val);
      var MACD = Math.floor(val.MACD * 100) / 100;
      var signal = Math.floor(val.signal * 100) / 100;
      var histogram = Math.floor(val.histogram * 100) / 100;
      return ["MACD:", MACD, " signal:", signal, " histogram:", histogram].join(
        "  "
      );
    },
    formatCCI: function (val) {
      if (!val || val == "") {
        return "";
      }

      if (val.constructor == Array) {
        return val.join("  ");
      }

      // val = JSON.parse(val);
      // if (val && val.length > 0) {
      //   return val.join("  ");
      // }
      //
    },
    formatSKDJ: function (val) {
      if (!val || val == "") {
        return "";
      }

      val = JSON.parse(val);
      var k = Math.floor(val.K * 100) / 100;
      var d = Math.floor(val.D * 100) / 100;
      return ["K:", k, " D:", d].join("  ");
    },
  },
  watch: {
    "pagination.currentPage": function (val) {
      this.getList();
    },

    marketId: function (val) {
      console.log("-----marketId:", val);
      this.pagination.currentPage = 1;
      this.reloadData();
    },

    period: function (val) {
      this.pagination.currentPage = 1;
      this.reloadData();
    },
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    // queriedData() {
    // let result = this.tableData;
    // if (this.searchedData.length > 0) {
    //   result = this.searchedData;
    // }
    // return result.slice(this.from, this.to);
    // },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }

      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
      // return this.searchedData.length > 0
      //   ? this.searchedData.length
      //   : this.tableData.length;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },

      tableData: [],
      periods: {},
      periodsAry: [],
      markets: [],
      marketId: 10014,
      period: "1min",
    };
  },
  created() {
    this.reloadData();
  },
  methods: {
    getDealConfig(id) {
      // console.log("getDealConfig:", id);
      for (var i = 0; i < this.dealConfigs.length; i++) {
        if (this.dealConfigs[i].id == id) {
          return this.dealConfigs[i];
        }
      }

      return false;
    },
    reloadData() {
      this.getList();
    },

    async reloadBuildAll() {
      var formData = {};

      if (this.marketId > 0) {
        formData.marketId = this.marketId;
      }

      if (this.period != "") {
        formData.period = this.period;
      }

      const { code } = await linearSwapApi.syncAllKLine(formData);

      if (code != 200) {
        return;
      }

      this.reloadData();
    },

    async reloadBuild() {
      var formData = {};

      if (this.marketId > 0) {
        formData.marketId = this.marketId;
      }

      if (this.period != "") {
        formData.period = this.period;
      }

      const { code } = await linearSwapApi.synckLines(formData);

      if (code != 200) {
        return;
      }

      this.reloadData();
    },

    async getList() {
      var formData = {
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.perPage,
      };

      if (this.marketId > 0) {
        formData.marketId = this.marketId;
      }

      if (this.period != "") {
        formData.period = this.period;
      }

      const { code, data } = await linearSwapApi.kLines(formData);

      if (code != 200) {
        return;
      }

      const { markets, list, total, periods } = data;

      console.log("-=---list:", list);

      this.periods = periods;
      this.tableData = list;
      this.markets = markets;
      this.markets.unshift({
        id: 0,
        symbol: "选择交易对",
      });

      let periodsAry = [];
      for (let key in periods) {
        periodsAry.push({ key, value: periods[key] });
      }
      this.periodsAry = periodsAry;

      this.pagination.total = total;
    },
  },
};
</script>

<style lang="scss" scoped>
.cardMadal .card-body {
  padding: 40px 0 0 35px !important;
}
</style>